<template>
    <div class="rest-menu" id="menu">
        <div class="rest-menu__info">
            <h2 class="rest-menu__info__title">{{ title }}</h2>
            <div class="rest-menu__info__text">
                {{ text }}<br /><br />
                {{ text2 }}
            </div>
            <div class="rest-menu__rests desktop">
                <div class="rest-menu__rests__rest">
                    <a :href="pdf_file" target="_blank">
                        <button class="rest-menu__show-menu">
                            {{ btn }}
                        </button>
                    </a>
                </div>
            </div>
        </div>
        <swiper
            :slides-per-view="1"
            :space-between="50"
            :modules="[Autoplay, EffectFade]"
            :loop="true"
            :speed="1"
            :autoplay="{ delay: 2500 }"
            :breakpoints="{
                320: { spaceBetween: 0 },
                769: { spaceBetween: 50 },
            }"
        >
            <swiper-slide v-for="image in images" :key="image.id" class="desktop">
                <img :src="require(`@/assets/images/animation/${image.img}`)" :alt="image.img"
            /></swiper-slide>
            <swiper-slide v-for="image in imagesMobile" :key="image.id" class="mobile">
                <img :src="require(`@/assets/images/animation/mobile/${image.img}`)" :alt="image.img"
            /></swiper-slide>
        </swiper>
        <div class="rest-menu__rests mobile">
            <div class="rest-menu__rests__rest">
                <a :href="pdf_file" target="_blank">
                    <button class="rest-menu__show-menu">
                        {{ btn }}
                    </button>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import { Autoplay, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/effect-fade";

export default {
    components: {
        Swiper,
        SwiperSlide,
    },
    data() {
        return {
            title: "Меню ресторанов",
            images: [
                { id: 1, img: "1.png" },
                { id: 2, img: "2.png" },
                { id: 3, img: "3.png" },
                { id: 4, img: "4.png" },
                { id: 5, img: "5.png" },
                { id: 6, img: "6.png" },
                { id: 7, img: "7.png" },
                { id: 8, img: "8.png" },
            ],
            imagesMobile: [
                { id: 1, img: "1.png" },
                { id: 2, img: "2.png" },
                { id: 3, img: "3.png" },
                { id: 4, img: "4.png" },
                { id: 5, img: "5.png" },
                { id: 6, img: "6.png" },
                { id: 7, img: "7.png" },
            ],
            pdf_file: "Меню_Zaman.pdf",
            btn: "Смотреть меню",
            text: `Наша кухня — это дорогие сердцу воспоминания: родная 
            деревня, треск дров в печи, ласковые руки бабушки. В меню — 
            проверенные поколениями рецепты татарских семей, которые 
            мы готовим с любовью, используя только лучшие местные 
            продукты.`,
            text2: `Мы сохраняем традиции, но смотрим в будущее. 
            В ресторане Zaman вы сможете почувствовать 
            настоящий вкус татарской кухни — искренний, тёплый 
            и щедрый.`,
        };
    },
    methods: {
        openMenu(str) {
            window.location.href = str;
        },
    },
    setup() {
        return {
            Autoplay,
            EffectFade,
        };
    },
};
</script>

<style scoped lang="scss">
.mobile {
    flex-direction: column !important;
    display: none !important;

    .rest-menu__show-menu {
        color: #2a374b !important;
    }
}
@media (max-width: 768px) {
    .desktop {
        display: none !important;
    }
    .mobile {
        display: flex !important;
    }
}
.rest-menu {
    background-color: #fafafa;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    @media (max-width: 768px) {
        flex-direction: column;
    }

    &__info {
        display: flex;
        flex-direction: column;
        padding: 50px 50px 75px 50px;
        @media (max-width: 768px) {
            padding: 30px 20px 0;
            text-align: center;
            margin-top: 20px;
        }
        &__title {
            font-size: 48px;
            font-weight: 600;
            line-height: 64px;
            color: #2a374b;
            @media (max-width: 768px) {
                font-size: 26px;
                line-height: 32px;
            }
        }
        &__text {
            font-size: 18px;
            line-height: 28px;
            color: #0d0d0d;
            white-space: pre-line;
            margin-top: 20px;
            @media (max-width: 768px) {
                font-size: 14px;
                line-height: 24px;
                white-space: normal;
            }
        }
    }
    &__rests {
        display: flex;
        flex-direction: row;
        gap: 48px;
        @media (max-width: 768px) {
            gap: 30px;
            width: 100%;
            padding: 0 20px;
        }
        &__rest a {
            text-decoration: none;
        }
    }
    &__show-menu {
        background: transparent;
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 70px;
        justify-content: space-between;
        border: 1px solid #2a374b;
        border-radius: 50px;
        width: 100%;
        height: 80px;
        padding: 0 50px;
        font-size: 20px;
        font-weight: 600;
        color: #2a374b;
        line-height: 160%;
        font-family: "Montserrat", sans-serif;
        margin-top: 50px;
        @media (max-width: 768px) {
            height: 64px;
            font-size: 16px;
            line-height: 24px;
            display: flex;
            justify-content: center;
            margin-top: 30px;
        }
        &:hover,
        &:focus {
            background: #2a374b;
            color: #fafafa;
            transition: 0.2s ease 0.2s;
        }
    }
}
.swiper {
    max-width: 741.57px;
    overflow: hidden;
    margin-right: -125px;
    height: 594px;
    @media (max-width: 768px) {
        width: 110vw;
        height: 100%;
        margin-right: 0;
        margin-left: 0;
        margin-top: 50px;
        margin-bottom: -50px;
        order: 1;
    }
}
.swiper-slide {
    width: 100% !important;
    height: 100%;
    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}
</style>
